import { SideNav as CanvasSideNav } from '@enterprise-ui/canvas-ui-react'
import styled from 'styled-components'

export const StyledNavItemHeader = styled(CanvasSideNav.Header)`
  justify-content: left;
  padding: 0 !important;

  &:hover {
    pointer-events: none;
    background-color: transparent;
  }
`
